import { render, staticRenderFns } from "./requestLogForm.vue?vue&type=template&id=ba0cfdfe&%23default=true&"
import script from "./requestLogForm.vue?vue&type=script&lang=js&"
export * from "./requestLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports